import React from 'react';
import '../styles/Footer.css'; // Create a separate CSS file for the footer

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2025 DriverGems Tech Pvt Ltd. All rights reserved. <a href="https://www.drivergems.com/privacypolicy.html" target="_blank" rel="noopener noreferrer">
              Privacy Policy</a></p>
            
        </footer>
    );
};

export default Footer;
